
    import { mapActions, mapGetters } from "vuex";
    import $ from 'jquery';
    import AlertConfirmDialog from '@/components/alert-confirm/alert-confirm-dialog.vue';
    import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
    import HeaderMarketing from "@/components/header-marketing.vue";
    import LoadingIndicator from '@/components/loading-indicator.vue';
    import ModalPopupRoot from '@/components/modal/modal-popup-root.vue';
    import ModalSlideRoot from '@/components/modal/modal-slide-root.vue';
    import Vue from 'vue';

    export default Vue.extend({
        name: "app",
        components: {
            "header-marketing": HeaderMarketing,
            "dashboard-layout": DashboardLayout,            
            "modal-slide-root": ModalSlideRoot,
            "modal-popup-root": ModalPopupRoot,
            "alert-confirm-dialog": AlertConfirmDialog,
            "loading-indicator": LoadingIndicator
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                currentPlayer: 'currentPlayer/currentPlayer'
            })
        },
        methods: {
            ...mapActions('currentPlayer', [
                'getCurrentPlayerAction'
            ]),
            ...mapActions([
                'getTennisSportIdAction',
                'getCountriesAction',
                'getTennisSurfacesAction',
                'getSportsAction'
            ]),
        },
        created() {
            // initialise the store!
            // pass 'true' to enforce a reload of the current player. 
            // Eventually we should just do this based on the staleness of the data
            this.getCurrentPlayerAction(true);          
            this.getTennisSportIdAction()
                .then(() => {
                    // relies on tennis sport ID having been loaded
                    this.getTennisSurfacesAction();         
                })
            this.getCountriesAction();
            this.getSportsAction(true);
        }
    });

    $(function() {
        // used to adjust the menu height for the public site
        const menuHeight = $("#nav-container").outerHeight(true);
        $("#header-container-space").css("height", String(menuHeight));
    });
